<template>
  <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-ph-manuals">

    <page-title :title="'Tutoriale'" :back="true"></page-title>

    <div v-for="(item, index) in manuals" :key="index">
      <item-downloads-file
          :index="index+1"
          :action="item.action"
          :slug="item.slug"
          :image="item.image"
          :file="item.file"
          :name="item.name">
      </item-downloads-file>
    </div>

    <div v-if="manuals.length === 0" class="text-center">
      <p><b>Brak poradników do pobrania.</b></p>
    </div>

  </div>
</template>

<script>
import api from '@/services/Api';
import { mapGetters, mapState } from 'vuex';
import PageTitle from '@/components/PageTitle.vue';
import ItemDownloadsFile from '@/items/ItemDownloadsFile.vue';

export default {
  name: 'PhManuals',
  components: { PageTitle, ItemDownloadsFile },
  data(){
    return {
      show: false,
    }
  },
  computed: {
    ...mapGetters('profile', ['getProfile']),
    ...mapState({
      errors: state => state.clients.errors,
      loading: state => state.clients.loading,
      manuals: state => state.profile.manuals,
    })
  },
  mounted(){
    this.$store.dispatch('profile/PROFILE_MANUALS').then(() => {
      this.show = true
    })
  }
}
</script>

<style lang="scss" scoped>
  ion-card-content{
    padding: 8px 12px;
  }
  ion-card-header{
    --background: #ffffff;
  }
</style>